// extracted by mini-css-extract-plugin
export default {"main":"IconButton_main__BBTtt","icon":"IconButton_icon__gD-f7","text":"IconButton_text__h06co","spinner":"IconButton_spinner__Jnjuj","rotate":"IconButton_rotate__eEzKR"};